module.exports = __webpack_public_path__ + "img/KW.52154852.png";